import * as React from 'react';

// COMPONENTS
import Button from './Button';

// ICONS
import { ReactComponent as CrossIcon } from '../assets/svg/close-small.svg';

// TYPES
interface FileType {
	id?: string;
	displayFileName?: string;
	link?: string;
	name?: string;
	size?: number;
	type?: string;
	uploadInProgress?: boolean;
	percentComplete?: number;
}

interface FilesListTypes {
	files?: FileType[];
	onChange?: any;
	multiple?: boolean;
	disabled?: boolean;
}

// NOTE: files are always passed in as an array, whether there are 1 or many
// The return for the callback will be a string or an array - depending on the multiple property

export const FilesList: React.FC<FilesListTypes> = ({ files, onChange, multiple = false, disabled }) => {
	const [removedFileIds, setRemovedFileIds] = React.useState<string[]>([]);

	const removeFile = (id: string | undefined) => {
		if (id !== undefined) {
			const newRemovedFileIds = removedFileIds.slice();
			newRemovedFileIds.push(id);
			if (onChange) {
				if (multiple) {
					// if multiple - return an array of ids
					onChange(newRemovedFileIds);
				} else {
					// if single - return only id
					onChange(id);
				}
			}

			setRemovedFileIds(newRemovedFileIds);
		}
	};

	return (
		<div className="files-list">
			{files &&
				files.length > 0 &&
				files.map((file, index) => {
					if (!removedFileIds.includes(file.id || '')) {
						return (
							<div
								key={file.id + '_' + index}
								className={`btn download-link ${disabled ? `disabled-file-download` : ``}`}
							>
								<span className="link-name">{file.displayFileName ? file.displayFileName : file.name}</span>
								{file.uploadInProgress ? (
									<>
										<span className="progress-bar" style={{ width: file.percentComplete + '%' }}></span>
										<span className="progress-text">{file.percentComplete + '%'}</span>
									</>
								) : (
									<div onClick={() => removeFile(file.id)}>
										<span className="link-text d-none d-lg-block">Remove</span>
										<CrossIcon className="link-icon d-block d-lg-none" />
									</div>
								)}
							</div>
						);
					} else {
						return null;
					}
				})}
		</div>
	);
};

export default FilesList;
